export function LoadingSpinner() {
  return (
    <div className="loading">
      <img
        src="https://css.brilliantearth.com/static/img/common/ajax-loading-y23.gif"
        width="66"
        height="66"
        alt="loading spinner"
      />
    </div>
  );
}
